<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        isAppPlay: false,
        users: 'dfsf'
      }
    },
    created() {

    },
    mounted() {
      
    },
    methods: {

    },
    components: {

    }
  }
</script>

<style lang="scss">
  body{
      -webkit-text-size-adjust: 100% !important;
  }
  body,
  html,
  #app {
    font-family: 'Microsoft YaHei';
    // height: 100%;
  }

  #app {
    width: 10rem;
    margin: auto;
  }
  iframe{
    display: none;
  }
  .flex {
    display: flex;
  }
  .query_back{
    position: fixed;
    left: 0.4rem;
    top: 50.22%;
    z-index: 1000;
    width: 1.093333rem;
    height: 1.093333rem;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .cent_runmor{
    img,div,p,span,ul,li{
      max-width: 100%;
    }
   font-size: 0.453333rem;
  }


  .queryAdministration{  //修改查询行政区的弹框
    .van-dropdown-item{
      width: 4rem;
      margin: auto;
     }

    .van-dropdown-menu__title {
      color: #fff !important;
      &:after{
          border: none;
      }
    }
  }


  .adim_Main {
    position: relative;
    animation: myadimate 2s linear infinite;
    -moz-animation: myadimate 2s linear infinite;
    -webkit-animation: myadimate 2s linear infinite;
    -o-animation: myadimate 2s linear infinite;
  }

  @keyframes myadimate {
    0% {
      top: 0
    }

    50% {
      top: 0.2rem
    }

    100% {
      top: 0
    }
  }

  @-moz-keyframes myadimate {
    0% {
      top: 0
    }

    50% {
      top: 0.2rem
    }

    100% {
      top: 0
    }
  }

  @-webkit-keyframes myadimate {
    0% {
      top: 0
    }

    50% {
      top: 0.2rem
    }

    100% {
      top: 0
    }
  }

  @-o-keyframes myadimate {
    0% {
      top: 0
    }

    50% {
      top: 0.2rem
    }

    100% {
      top: 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue